import { render, staticRenderFns } from "./RefreshData.vue?vue&type=template&id=3064add8&scoped=true&lang=pug"
import script from "./RefreshData.vue?vue&type=script&lang=js"
export * from "./RefreshData.vue?vue&type=script&lang=js"
import style0 from "./RefreshData.vue?vue&type=style&index=0&id=3064add8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3064add8",
  null
  
)

export default component.exports